import { UserSettingId } from 'src/graphql/entities/user-setting-value/user-setting-value.types';
import { useUserSetting } from './use-user-setting';

/** Whether the left panel's Active policies preview is folded to its header. */
export function usePolicyPreviewMinimizedSetting(): readonly [
  boolean,
  (next: boolean) => void,
] {
  return useUserSetting<boolean>(UserSettingId.PolicyPreviewMinimized, {
    valueType: 'boolean',
    decode: (raw) => raw === true,
    encode: (next) => (next ? 'true' : 'false'),
  });
}
